import {
  faBoxOpenFull,
  faBuilding,
  faBuildingUser,
  faCartPlus,
  faFolderPlus,
  faShieldCheck,
  type IconDefinition,
} from "@fortawesome/pro-solid-svg-icons";
import styles from "./addOnIcon.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export interface AddOnIconProps {
  id: number;
}

const iconMap: { [key: number]: IconDefinition } = {
  1: faFolderPlus, // Manage Content
  2: faBuilding, // Manage Accounts
  3: faCartPlus, // Marketplace
  4: faShieldCheck, // Threat Defense
  5: faBoxOpenFull, // Purchase Packs
  6: faBuildingUser, // Manage Templates
};

export default function AddOnIcon({ id }: AddOnIconProps) {
  return <FontAwesomeIcon icon={iconMap[id]} className={styles.icon} size="xl" />;
}
